/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseDataResponse_VacationApplicationFileUrlResponse_ } from '../models/BaseDataResponse_VacationApplicationFileUrlResponse_';
import type { BaseDataResponse_VacationApplicationResponse_ } from '../models/BaseDataResponse_VacationApplicationResponse_';
import type { BaseDataResponse_VacationTemplateFileResponse_ } from '../models/BaseDataResponse_VacationTemplateFileResponse_';
import type { BaseListDataResponse_VacationApplicationResponse_ } from '../models/BaseListDataResponse_VacationApplicationResponse_';
import type { Body_upload_temp_file_api_vacation_applications_upload_temp_post } from '../models/Body_upload_temp_file_api_vacation_applications_upload_temp_post';
import type { CreateMyVacationApplicationRequest } from '../models/CreateMyVacationApplicationRequest';
import type { RescheduleMyVacationRequest } from '../models/RescheduleMyVacationRequest';
import type { UpdateVacationApplicationDatesRequest } from '../models/UpdateVacationApplicationDatesRequest';
import type { UploadMyVacationSignedOrderRequest } from '../models/UploadMyVacationSignedOrderRequest';
import type { UploadVacationOrderRequest } from '../models/UploadVacationOrderRequest';
import type { UploadVacationSignedOrderRequest } from '../models/UploadVacationSignedOrderRequest';
import type { VacationApplicationStatus } from '../models/VacationApplicationStatus';
import { VacationApplicationType } from '../models/VacationApplicationType';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class VacationApplicationsService {
    /**
     * List My Vacation Applications
     * Получение списка своих заявок на отпуск
     * @param status Фильтр по типу отпуска
     * @param limit Лимит
     * @param offset Смещение
     * @returns BaseListDataResponse_VacationApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static listMyVacationApplicationsApiVacationApplicationsMeGet(
        status?: (VacationApplicationType | null),
        limit: number = 50,
        offset?: number,
    ): CancelablePromise<BaseListDataResponse_VacationApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/vacation/applications/me',
            query: {
                'status': status,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                401: `Code: authentication_error`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Create My Vacation Application
     * Создание заявки на отпуск от имени текущего пользователя
     * @param requestBody
     * @returns BaseDataResponse_VacationApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static createMyVacationApplicationApiVacationApplicationsMePost(
        requestBody: CreateMyVacationApplicationRequest,
    ): CancelablePromise<BaseDataResponse_VacationApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/vacation/applications/me',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Code: authentication_error`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Get My Vacation Application
     * Получение своей заявки на отпуск по ID
     * @param applicationId
     * @returns BaseDataResponse_VacationApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static getMyVacationApplicationApiVacationApplicationsMeApplicationIdGet(
        applicationId: string,
    ): CancelablePromise<BaseDataResponse_VacationApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/vacation/applications/me/{application_id}',
            path: {
                'application_id': applicationId,
            },
            errors: {
                401: `Code: authentication_error`,
                404: `Code: vacation_application_not_found`,
                422: `Validation Error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Get My Vacation Application File Url
     * Получение временной ссылки на файл своей заявки на отпуск
     * @param applicationId
     * @param expiresIn Время действия ссылки в секундах
     * @returns BaseDataResponse_VacationApplicationFileUrlResponse_ Successful Response
     * @throws ApiError
     */
    public static getMyVacationApplicationFileUrlApiVacationApplicationsMeApplicationIdFileUrlGet(
        applicationId: string,
        expiresIn: number = 3600,
    ): CancelablePromise<BaseDataResponse_VacationApplicationFileUrlResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/vacation/applications/me/{application_id}/file-url',
            path: {
                'application_id': applicationId,
            },
            query: {
                'expires_in': expiresIn,
            },
            errors: {
                400: `Code: vacation_application_not_file`,
                401: `Code: authentication_error`,
                404: `Code: vacation_application_not_found`,
                422: `Validation Error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Get My Vacation Order File Url
     * Получение временной ссылки на неподписанный приказ своей заявки на отпуск
     * @param applicationId
     * @param expiresIn Время действия ссылки в секундах
     * @returns BaseDataResponse_VacationApplicationFileUrlResponse_ Successful Response
     * @throws ApiError
     */
    public static getMyVacationOrderFileUrlApiVacationApplicationsMeApplicationIdOrderUrlGet(
        applicationId: string,
        expiresIn: number = 3600,
    ): CancelablePromise<BaseDataResponse_VacationApplicationFileUrlResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/vacation/applications/me/{application_id}/order-url',
            path: {
                'application_id': applicationId,
            },
            query: {
                'expires_in': expiresIn,
            },
            errors: {
                400: `Code: vacation_application_not_file`,
                401: `Code: authentication_error`,
                404: `Code: vacation_application_not_found`,
                422: `Validation Error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Get My Vacation Signed Order File Url
     * Получение временной ссылки на подписанный приказ своей заявки на отпуск
     * @param applicationId
     * @param expiresIn Время действия ссылки в секундах
     * @returns BaseDataResponse_VacationApplicationFileUrlResponse_ Successful Response
     * @throws ApiError
     */
    public static getMyVacationSignedOrderFileUrlApiVacationApplicationsMeApplicationIdSignedOrderUrlGet(
        applicationId: string,
        expiresIn: number = 3600,
    ): CancelablePromise<BaseDataResponse_VacationApplicationFileUrlResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/vacation/applications/me/{application_id}/signed-order-url',
            path: {
                'application_id': applicationId,
            },
            query: {
                'expires_in': expiresIn,
            },
            errors: {
                400: `Code: vacation_application_not_file`,
                401: `Code: authentication_error`,
                404: `Code: vacation_application_not_found`,
                422: `Validation Error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Upload My Vacation Signed Order
     * Загрузка подписанного приказа на отпуск от имени текущего пользователя
     * @param applicationId
     * @param requestBody
     * @returns BaseDataResponse_VacationApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static uploadMyVacationSignedOrderApiVacationApplicationsMeApplicationIdSignedOrderPost(
        applicationId: string,
        requestBody: UploadMyVacationSignedOrderRequest,
    ): CancelablePromise<BaseDataResponse_VacationApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/vacation/applications/me/{application_id}/signed-order',
            path: {
                'application_id': applicationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Code: authentication_error`,
                404: `Code: vacation_application_not_found`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Confirm My Vacation
     * Подтверждение отпуска текущим пользователем
     * @param applicationId
     * @returns BaseDataResponse_VacationApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static confirmMyVacationApiVacationApplicationsMeApplicationIdConfirmPost(
        applicationId: string,
    ): CancelablePromise<BaseDataResponse_VacationApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/vacation/applications/me/{application_id}/confirm',
            path: {
                'application_id': applicationId,
            },
            errors: {
                400: `Code: vacation_application_already_confirmed`,
                401: `Code: authentication_error`,
                404: `Code: vacation_application_not_found`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Cancel My Vacation
     * Отмена отпуска текущим пользователем
     * @param applicationId
     * @returns BaseDataResponse_VacationApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static cancelMyVacationApiVacationApplicationsMeApplicationIdCancelPost(
        applicationId: string,
    ): CancelablePromise<BaseDataResponse_VacationApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/vacation/applications/me/{application_id}/cancel',
            path: {
                'application_id': applicationId,
            },
            errors: {
                400: `Code: vacation_application_already_confirmed`,
                401: `Code: authentication_error`,
                404: `Code: vacation_application_not_found`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Reschedule My Vacation
     * Перенос отпуска текущим пользователем
     * @param applicationId
     * @param requestBody
     * @returns BaseDataResponse_VacationApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static rescheduleMyVacationApiVacationApplicationsMeApplicationIdReschedulePost(
        applicationId: string,
        requestBody: RescheduleMyVacationRequest,
    ): CancelablePromise<BaseDataResponse_VacationApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/vacation/applications/me/{application_id}/reschedule',
            path: {
                'application_id': applicationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Code: vacation_application_already_confirmed`,
                401: `Code: authentication_error`,
                404: `Code: vacation_application_not_found`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Upload Temp File
     * Загрузка временного файла. Файл автоматически удалится через 10 минут.
     * @param formData
     * @returns BaseDataResponse_VacationApplicationFileUrlResponse_ Successful Response
     * @throws ApiError
     */
    public static uploadTempFileApiVacationApplicationsUploadTempPost(
        formData: Body_upload_temp_file_api_vacation_applications_upload_temp_post,
    ): CancelablePromise<BaseDataResponse_VacationApplicationFileUrlResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/vacation/applications/upload-temp',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                401: `Code: authentication_error`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Get Application Template
     * Получение шаблона заявления на отпуск
     * @param type Тип отпуска (paid/unpaid)
     * @returns BaseDataResponse_VacationTemplateFileResponse_ Successful Response
     * @throws ApiError
     */
    public static getApplicationTemplateApiVacationApplicationsTemplateGet(
        type: VacationApplicationType = VacationApplicationType.PAID,
    ): CancelablePromise<BaseDataResponse_VacationTemplateFileResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/vacation/applications/template',
            query: {
                'type': type,
            },
            errors: {
                401: `Code: authentication_error`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * List Vacation Applications
     * Получение списка заявок на отпуск с фильтрацией
     * @param status Фильтр по статусу
     * @param userId Фильтр по ID пользователя
     * @param userSearch Поиск по username, email или full_name (частичное совпадение)
     * @param applicationType Фильтр по типу отпуска
     * @param limit Лимит
     * @param offset Смещение
     * @returns BaseListDataResponse_VacationApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static listVacationApplicationsApiVacationApplicationsGet(
        status?: (VacationApplicationStatus | null),
        userId?: (string | null),
        userSearch?: (string | null),
        applicationType?: (VacationApplicationType | null),
        limit: number = 50,
        offset?: number,
    ): CancelablePromise<BaseListDataResponse_VacationApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/vacation/applications',
            query: {
                'status': status,
                'user_id': userId,
                'user_search': userSearch,
                'application_type': applicationType,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                401: `Code: authentication_error`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Get Vacation Application
     * Получение заявки на отпуск по ID
     * @param applicationId
     * @returns BaseDataResponse_VacationApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static getVacationApplicationApiVacationApplicationsApplicationIdGet(
        applicationId: string,
    ): CancelablePromise<BaseDataResponse_VacationApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/vacation/applications/{application_id}',
            path: {
                'application_id': applicationId,
            },
            errors: {
                401: `Code: authentication_error`,
                404: `Code: vacation_application_not_found`,
                422: `Validation Error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Get Vacation Application File Url
     * Получение временной ссылки на файл заявки на отпуск
     * @param applicationId
     * @param expiresIn Время действия ссылки в секундах
     * @returns BaseDataResponse_VacationApplicationFileUrlResponse_ Successful Response
     * @throws ApiError
     */
    public static getVacationApplicationFileUrlApiVacationApplicationsApplicationIdFileUrlGet(
        applicationId: string,
        expiresIn: number = 3600,
    ): CancelablePromise<BaseDataResponse_VacationApplicationFileUrlResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/vacation/applications/{application_id}/file-url',
            path: {
                'application_id': applicationId,
            },
            query: {
                'expires_in': expiresIn,
            },
            errors: {
                400: `Code: vacation_application_not_file`,
                401: `Code: authentication_error`,
                404: `Code: vacation_application_not_found`,
                422: `Validation Error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Update Vacation Application Dates Endpoint
     * Обновление дат отпуска в заявке
     * @param applicationId
     * @param requestBody
     * @returns BaseDataResponse_VacationApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static updateVacationApplicationDatesEndpointApiVacationApplicationsApplicationIdDatesPut(
        applicationId: string,
        requestBody: UpdateVacationApplicationDatesRequest,
    ): CancelablePromise<BaseDataResponse_VacationApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/vacation/applications/{application_id}/dates',
            path: {
                'application_id': applicationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Code: invalid_vacation_application_dates`,
                401: `Code: authentication_error`,
                404: `Code: vacation_application_not_found`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Send Vacation Planned Notification Endpoint
     * Отправка нотификации пользователю о запланированном отпуске.
     *
     * Нотификация отправляется в Telegram с inline кнопками: Пойду, Перенесу, Отменю.
     * @param applicationId
     * @returns void
     * @throws ApiError
     */
    public static sendVacationPlannedNotificationEndpointApiVacationApplicationsApplicationIdNotifyPlannedPost(
        applicationId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/vacation/applications/{application_id}/notify-planned',
            path: {
                'application_id': applicationId,
            },
            errors: {
                400: `Code: vacation_application_dates_not_specified`,
                401: `Code: authentication_error`,
                404: `Code: vacation_application_not_found`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Send Vacation Order Signing Notification Endpoint
     * Отправка нотификации пользователю о необходимости подписать приказ на отпуск.
     *
     * Нотификация отправляется только если заявка в статусе ORDER_SIGNING.
     * @param applicationId
     * @returns void
     * @throws ApiError
     */
    public static sendVacationOrderSigningNotificationEndpointApiVacationApplicationsApplicationIdNotifyOrderSigningPost(
        applicationId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/vacation/applications/{application_id}/notify-order-signing',
            path: {
                'application_id': applicationId,
            },
            errors: {
                400: `Code: vacation_notification_not_available`,
                401: `Code: authentication_error`,
                404: `Code: vacation_application_not_found`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Upload Vacation Order Endpoint
     * Загрузка приказа на отпуск (бухгалтером)
     * @param applicationId
     * @param requestBody
     * @returns BaseDataResponse_VacationApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static uploadVacationOrderEndpointApiVacationApplicationsApplicationIdOrderPost(
        applicationId: string,
        requestBody: UploadVacationOrderRequest,
    ): CancelablePromise<BaseDataResponse_VacationApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/vacation/applications/{application_id}/order',
            path: {
                'application_id': applicationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Code: authentication_error`,
                404: `Code: vacation_application_not_found`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Upload Vacation Signed Order Endpoint
     * Загрузка подписанного приказа на отпуск (бухгалтером)
     * @param applicationId
     * @param requestBody
     * @returns BaseDataResponse_VacationApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static uploadVacationSignedOrderEndpointApiVacationApplicationsApplicationIdSignedOrderPost(
        applicationId: string,
        requestBody: UploadVacationSignedOrderRequest,
    ): CancelablePromise<BaseDataResponse_VacationApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/vacation/applications/{application_id}/signed-order',
            path: {
                'application_id': applicationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Code: authentication_error`,
                404: `Code: vacation_application_not_found`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Revert Vacation To Order Signing Endpoint
     * Возврат заявки на отпуск к статусу order_signing
     * @param applicationId
     * @returns BaseDataResponse_VacationApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static revertVacationToOrderSigningEndpointApiVacationApplicationsApplicationIdRevertToOrderSigningPost(
        applicationId: string,
    ): CancelablePromise<BaseDataResponse_VacationApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/vacation/applications/{application_id}/revert-to-order-signing',
            path: {
                'application_id': applicationId,
            },
            errors: {
                401: `Code: authentication_error`,
                404: `Code: vacation_application_not_found`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Get Vacation Order File Url
     * Получение временной ссылки на приказ отпуска
     * @param applicationId
     * @param expiresIn Время действия ссылки в секундах
     * @returns BaseDataResponse_VacationApplicationFileUrlResponse_ Successful Response
     * @throws ApiError
     */
    public static getVacationOrderFileUrlApiVacationApplicationsApplicationIdOrderUrlGet(
        applicationId: string,
        expiresIn: number = 3600,
    ): CancelablePromise<BaseDataResponse_VacationApplicationFileUrlResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/vacation/applications/{application_id}/order-url',
            path: {
                'application_id': applicationId,
            },
            query: {
                'expires_in': expiresIn,
            },
            errors: {
                400: `Code: vacation_application_not_file`,
                401: `Code: authentication_error`,
                404: `Code: vacation_application_not_found`,
                422: `Validation Error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Get Vacation Signed Order File Url
     * Получение временной ссылки на подписанный приказ отпуска
     * @param applicationId
     * @param expiresIn Время действия ссылки в секундах
     * @returns BaseDataResponse_VacationApplicationFileUrlResponse_ Successful Response
     * @throws ApiError
     */
    public static getVacationSignedOrderFileUrlApiVacationApplicationsApplicationIdSignedOrderUrlGet(
        applicationId: string,
        expiresIn: number = 3600,
    ): CancelablePromise<BaseDataResponse_VacationApplicationFileUrlResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/vacation/applications/{application_id}/signed-order-url',
            path: {
                'application_id': applicationId,
            },
            query: {
                'expires_in': expiresIn,
            },
            errors: {
                400: `Code: vacation_application_not_file`,
                401: `Code: authentication_error`,
                404: `Code: vacation_application_not_found`,
                422: `Validation Error`,
                500: `Code: internal_server_error`,
            },
        });
    }
}
